import actions from "@/core/store/modules/auth/actions";
import getters from "@/core/store/modules/auth/getters";
import mutations from "@/core/store/modules/auth/mutations";
import storage from "@/core/services/storage.service";


export default {
    state: {
        accessToken: storage.getToken(),
        oauthServices: [],
        oauthServicesBooted:false
    },
    getters,
    mutations,
    actions
}